<form [formGroup]="form" #formDirective="ngForm" (ngSubmit)="gravarOuAlterar()">
  <div class="card mb-3 bg-2">
    <div class="card-body">
      <div class="row">
        <div class="col-sm-12 col-xl-6">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>Nome</mat-label>
            <input placeholder="Nome" matInput type="text" formControlName="nome" maxlength="150" required>
          </mat-form-field>
        </div>
      </div>
      <div class="row mt-1">
        <div class="w-100 ml-0 col-12 border-bottom" *ngIf="composta === false">
          <label class="label-maps">Função</label>
        </div>
      </div>
      <div class="row" *ngIf="composta === false">
        <div class="mt-3 col-sm-12 col-md-6 col-lg-4 col-xl-2 categoria-funcao">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>Categoria</mat-label>
            <mat-select formControlName="categoria" [compareWith]="compareEnumCategoria" [disabled]="form.controls.categoria.disabled">
              <mat-option [value]="''">Selecione uma opção</mat-option>
              <mat-option *ngFor="let categoria of categorias" [value]="categoria">{{categoria}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="mt-3 col-sm-12 col-md-6 col-lg-8 col-xl-4 funcao">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>Função</mat-label>
            <input type="text"
                   placeholder=""
                   aria-label="Função"
                   matInput
                   formControlName="funcoes"
                   [matAutocomplete]="auto">
            <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="selecionarFuncao($event.option.value)" [displayWith]="displayFn">
              <mat-option *ngFor="let option of filteredFuncoes" [value]="option">
                {{option.nome}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
      </div>
      <div class="row p-3" *ngIf="funcaoSelecionada">
        <div class="w-100 desc-funcao">
          <label class="label-maps">Descrição</label>
          <div class="border p-3 mr-3 w-100">
            <p [innerHTML]="funcaoSelecionada.descricao"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="card mt-2 mb-5 bg-2" *ngIf="funcaoSelecionada">
    <div class="card-body">
      <div class="row d-flex align-items-center no-field-padding pb-2">
        <div class="col-sm-6 col-md-4 col-xl-2">
          <lib-datepicker-day-enq #cadastroRegraDataInicioVigencia [schema]="dataInicioSchema"></lib-datepicker-day-enq>
        </div>
        <div class="col-sm-6 col-md-4 col-xl-2">
          <lib-datepicker-day-enq #cadastroRegraDataFimVigencia [schema]="dataFimSchema"></lib-datepicker-day-enq>
        </div>
        <div class="col-sm-6 col-md-5 col-xl-3" *ngIf="canExplosao">
          <mat-slide-toggle [color]="'primary'" formControlName="utilizaCarteiraExplodida">Utilizar carteira explodida</mat-slide-toggle>
        </div>
      </div>
      <div class="container-fluid mt-2">
        <div class="row border parametro-header">
          <div class="d-flex w-20 justify-content-center flex-shrink-1 p border-right p-4 text-center font-weight-bold">Parâmetro</div>
          <div class="d-flex w-35 justify-content-center flex-shrink-1 p p-4 text-center font-weight-bold">Valor</div>
          <div class="d-flex w-45 justify-content-center border-left p-4 text-center font-weight-bold">Descrição</div>
        </div>
        <div class="row border mt-2  d-flex align-items-stretch parametro-body" *ngFor="let param of funcaoSelecionada.parametros">
          <div class="d-flex border-right w-20 flex-shrink-1 p-4 align-items-center">{{param.label}}</div>
          <div class="d-flex w-35 flex-shrink-1 p-4 align-items-center">
            <parametro-funcao
              [item]="param"
              [parentForm]="form.get('parametros')"
              [parametrosRegra]="parametrosRegra"
              [isConsulta]="this.isConsulta"
              style="width: 100%;">
            </parametro-funcao>
          </div>
          <div class="d-flex w-45 border-left p-4 align-items-center param-descricao"><p [innerHTML]="param.descricao"></p></div>
        </div>
      </div>
    </div>
    <div class="card-footer clearfix container-fluid" *ngIf="composta === false && this.isConsulta === false">
      <div class="d-flex flex-row justify-content-end">
        <div class="pr-3">
          <button *ngIf="this._isDiolog" mat-raised-button mat-dialog-close type="button" label="Voltar" title="Voltar"
                  data-dismiss="modal"
                  aria-label="Close">Voltar
          </button>
        </div>
        <div>
          <button mat-raised-button color="primary" [disabled]="form.invalid" label="Gravar" title="Gravar"
                  type="submit">Gravar
          </button>
        </div>
      </div>
    </div>
  </div>
</form>
